import { useQuery } from '@tanstack/react-query';
import { configAdminService } from '@/services/configAdminService';
import type { SystemConfigRow } from '@/types/systemConfig';
import { queryKeys } from '@/lib/queryKeys';
import { useAuth } from '@/hooks/useAuth';

export const useAdminConfigs = (prefix?: string) => {
  const { isAuthenticated } = useAuth();
  return useQuery<SystemConfigRow[]>({
    queryKey: queryKeys.adminConfig.list(prefix),
    queryFn: () => configAdminService.list(prefix),
    enabled: isAuthenticated,
    staleTime: 0,
    refetchOnMount: 'always',
  });
};
